var searchFieldStylePropsMapper = function searchFieldStylePropsMapper(isDisabled) {
  return isDisabled ? {
    backgroundColor: 'deprecated.neutral.disabled-1',
    placeholderTextColor: 'base.disabled',
    inputTextColor: 'base.disabled',
    labelTextColor: 'base.disabled'
  } : {
    backgroundColor: 'deprecated.neutral.4',
    placeholderTextColor: 'base.subtle',
    inputTextColor: 'deprecated.secondary.interactive',
    labelTextColor: 'base.subtle'
  };
};

export { searchFieldStylePropsMapper };
//# sourceMappingURL=SearchField.mapper.js.map
